<template>
  <q-dialog class="theme-1" v-model="show" @hide="onClose" position="top" >
    <div class="card bg-white mt-4">
      <div class="card-body">
      
        <span class="font-size-14 d-block">{{dialogState.message}}</span>
        
      </div>

      <div class="card-footer d-flex justify-content-end">
       
        <q-btn class="btn text-body mr-2" color="transparent" :label="dialogState?.cancelButton ? dialogState.cancelButton : $t('main.confirmationDialog.cancelButton')" @click="onCancel" />
        <q-btn class="btn btn-danger" :label="dialogState?.confirmButton ? dialogState.confirmButton : $t('main.confirmationDialog.confirmationButton')" @click="onConfirm"/>
        </div>
    
    </div>

  </q-dialog>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {Emit} from "vue-property-decorator";
import store from "@/store";
import router from "@/router";

@Options({
  props: {
    show: Boolean
  }
})
export default class ConfirmationDialog extends Vue {

  name = 'confirmation-dialog'
  show?: boolean;

  get dialogState() {
    return store.state.confirmationDialogState
  }

   @Emit("onConfirm")
  onConfirm() {
    const target = this.dialogState?.target || ''
   if (this.dialogState?.action){
       store.dispatch('executeConfirmationDialog',{payload: this.dialogState?.payload, action:this.dialogState?.action, target:this.dialogState?.target })
   }
   else { 
   store.dispatch('releaseLockState').then(() => {
      router.push(target)
    })
  }
  }


  @Emit("onCancel")
  onCancel() {
    store.dispatch('hideConfirmationDialog')
  }

  @Emit("onClose")
  onClose() {
    store.dispatch('hideConfirmationDialog')
  }

}
</script>

<style scoped>
button{
  border-radius: 10px;
}
</style>
